export const AnimationColors: string[] = [
  "aqua",
  "bisque",
  "lightcyan",
  "orange",
  "beige",
];
